#import "../../../../CorporateChartOfAccountsFields.graphql"
mutation CorporateChartOfAccountUpdate(
  $input: CorporateChartOfAccountUpdateInput!
) {
  corporateChartOfAccountUpdate(input: $input) {
    corporateChartOfAccount {
      ...CorporateChartOfAccountsFields
    }
  }
}
